/**
 * Order item holes
 *
 * @author Erik Orozco <erik.orozco@buildcentrix.com>
 * @copyright (c) 2025 Build Centrix
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WdOrderItemHolesService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  /**
   * Check if fullfilment group includes items with holes
   */
  checkIfFulfillmentGroupHasHoleData(group: any): boolean {
    if (group.fittingsDataSource?.data?.length) {
      for (const item of group.fittingsDataSource.data) {
        if (item.holes?.length) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Cerate and download hole data report as txt file
   */
  downloadHoleDataReport(group: any, orderInfo: { title: string }): void {
    this.parseOrderItemsHoleData(group);
    const reportData = this.buildOrderItemHolesData(
      group.fittingsDataSource.data,
    );
    const filename = `${orderInfo.title} - Hole Data Report.txt`;
    this.downloadOrderHoleDataTextFile(filename, reportData);
  }

  /**
   * Bulilds order items hole raw data
   */
  private buildOrderItemHolesData(orderItems): string {
    let orderRawData = '';
    for (const orderItem of orderItems) {
      if (orderItem.holes?.length) {
        const itemRawData = this.bulidItemHoleData(orderItem);
        orderRawData = `${orderRawData}${itemRawData}`;
      }
    }
    return orderRawData;
  }

  /**
   * Bulilds item hole raw data
   */
  private bulidItemHoleData(item: any): string {
    let result = '';
    for (const {
      type,
      side,
      inset,
      offset,
      rotation,
      angle,
      width,
      depth,
      radius,
      collar,
      joint,
    } of item.holes) {
      result = `${result}Item #${item.referenceNumber} - Type=${type}, Side=${side}, Inset=${inset}, Offset=${offset}, Rotation=${rotation}, Angle=${angle}, Width=${width}, Depth=${depth}, Radius=${radius}, Collar=${collar}, Joint=${joint}\n`;
    }
    return result;
  }

  /**
   * Download any string data as a txt file
   */
  private downloadOrderHoleDataTextFile(
    filename: string,
    content: string,
  ): void {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  /**
   * Parses order items hole data to display it on hole data report
   */
  private parseOrderItemsHoleData(group: any) {
    group?.fittingsDataSource.data.forEach((item) =>
      this.parseItemHoleData(item),
    );
  }

  /**
   * Parses order item hole data to display it on hole data report
   */
  parseItemHoleData(item: any): void {
    item.holes = item?.holes?.map((hole) => {
      const holeNumber = hole.id?.replace('hole', '');
      const joint = hole[`H${holeNumber}`];
      return {
        ...hole,
        number: holeNumber,
        joint: typeof joint === 'object' ? joint.label : joint,
      };
    });
  }
}
